import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

import { TableHead } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface SortableHeaderProps {
  field: string;
  label: string;
  currentField: string;
  currentDir: 'asc' | 'desc';
  onToggle: (field: string) => void;
  className?: string;
}

export function SortableHeader({
  field,
  label,
  currentField,
  currentDir,
  onToggle,
  className,
}: SortableHeaderProps) {
  const isActive = currentField === field;

  return (
    <TableHead
      className={cn('cursor-pointer select-none', className)}
      onClick={() => onToggle(field)}
    >
      <div className="flex items-center gap-1">
        {label}
        {isActive ? (
          currentDir === 'asc' ? (
            <ArrowUp className="h-3.5 w-3.5" />
          ) : (
            <ArrowDown className="h-3.5 w-3.5" />
          )
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5 text-muted-foreground/50" />
        )}
      </div>
    </TableHead>
  );
}
